import {
  useTabNavigation,
  UseTabNavigationConfig,
} from "@/hooks/useTabNavigation";
import { type TabWithContent } from "@/components/TabsWithNavigation";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@/routes/paths";

interface UseSendBulkMessageConfig {
  completionMode?: "navigation" | "content";
  initialCompletedTabs?: string[];
  bulkMessageId?: string;
}

export const useSendBulkMessage = (config: UseSendBulkMessageConfig = {}) => {
  const { t } = useTranslation();
  const { bulkMessageId } = config;

  // Define the routes for the bulk messaging flow
  const routes: TabWithContent[] = [
    {
      id: ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.BASIC_INFORMATION,
      route: bulkMessageId
        ? "editBulkMessagingBasicInfo"
        : "bulkMessageBasicInfo",
      params: bulkMessageId ? { bulkMessageId } : undefined,
      handle: { name: t("bulkMessaging.basicInformation.title") },
      content: {
        title: t("bulkMessaging.basicInformation.title"),
        subtitle: t("bulkMessaging.basicInformation.subtitle"),
      },
    },
    {
      id: ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.COMPOSE_MESSAGE,
      route: bulkMessageId ? "editBulkMessagingCompose" : "bulkMessageCompose",
      params: bulkMessageId ? { bulkMessageId } : undefined,
      handle: { name: t("bulkMessaging.composeMessage.title") },
      content: {
        title: t("bulkMessaging.composeMessage.title"),
        subtitle: t("bulkMessaging.composeMessage.subtitle"),
      },
    },
    {
      id: ROUTES.COMMUNITY_TOOLS.BULK_MESSAGING.REVIEW,
      route: bulkMessageId ? "editBulkMessagingReview" : "bulkMessageReview",
      params: bulkMessageId ? { bulkMessageId } : undefined,
      handle: { name: t("bulkMessaging.review.title") },
      content: {
        title: t("bulkMessaging.review.title"),
        subtitle: t("bulkMessaging.review.subtitle"),
      },
    },
  ];

  // Business logic handlers
  const handleSaveDraft = () => {
    console.log("Saving draft...");
    // Implement save draft logic
  };

  const handleSubmit = () => {
    console.log("Submitting bulk message...");
    // Implement submit logic
  };

  // Use the generic tab navigation hook with bulk messaging configuration
  const tabNavigationConfig: UseTabNavigationConfig = {
    routes,
    title: t("bulkMessaging.title"),
    onSaveDraft: handleSaveDraft,
    onSubmit: handleSubmit,
    completionMode: config.completionMode || "navigation",
    initialCompletedTabs: config.initialCompletedTabs,
  };

  return useTabNavigation(tabNavigationConfig);
};
